import { memo } from 'react';

import type {
  ACHIEVEMENT_TIERS,
  ACHIEVEMENT_TYPES,
} from '@didaskill/domain/user-achievements/constants';
import {
  Achievement,
  CARD_VARIANTS,
  Dialog,
  type DialogProps,
  Typography,
} from '@didaskill/ui/design-system';

import { ACHIEVEMENT_TILE_VARIANTS_MAP } from '../constants';
import * as styles from './AchievementTileDialog.styles';

type AchievementTileDialogProps = {
  achievementTier: ACHIEVEMENT_TIERS;
  achievementType: ACHIEVEMENT_TYPES;
  title: string;
  description: string;
  isOwned: boolean;
} & DialogProps;

const AchievementTileDialogBase = ({
  achievementType,
  achievementTier,
  title,
  description,
  isOwned,
  ...props
}: AchievementTileDialogProps) => {
  return (
    <Dialog
      {...props}
      withBorder={false}
      size={Dialog.SIZES.SMALL}
      variant={
        isOwned
          ? (ACHIEVEMENT_TILE_VARIANTS_MAP[achievementTier].toUpperCase() as CARD_VARIANTS)
          : CARD_VARIANTS.DISABLED
      }
    >
      <Dialog.Body>
        <div css={styles.achievementTileDialogBody}>
          <Achievement
            type={achievementType}
            tier={achievementTier}
            size={Achievement.SIZES.LARGE}
            isDisabled={!isOwned}
          />

          <div css={styles.achievementTileDialogText}>
            <Typography variant={Typography.VARIANTS.BODY_LARGE_BOLD}>{title}</Typography>

            <Typography variant={Typography.VARIANTS.BODY_LARGE_REGULAR}>{description}</Typography>
          </div>
        </div>
      </Dialog.Body>
    </Dialog>
  );
};

export const AchievementTileDialog = memo(AchievementTileDialogBase);
